import { adminHttpClient } from '../commons/adminHttpClient'

export type AppConfigurationResponse = {
  key: string
  value: string
}

const getAllAppConfigurations = (): Promise<AppConfigurationResponse[]> => {
  return adminHttpClient.get('/AppConfigurations', {})
}

export default getAllAppConfigurations
